module.exports = __webpack_public_path__ + "static/fingerprints-of-the-gods-148d8ba8d1e327000b03410609d383b3.jpg";